// extracted by mini-css-extract-plugin
export default {"Modal":"ModalWithBackground_Modal__W+l9d","closeBtn":"ModalWithBackground_closeBtn__JafO5"};